import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import TopBar from '../../../components/TopBar/TopBar'

import InterestsSelector from '../views/InterestsSelector/InterestsSelector'
import AgeSelector from '../views/AgeSelector/AgeSelector'

import { STEPS_ENUM, INTERESTS_STEP_PARENT_TAGS_NAMES, AGE_STEP_PARENT_TAGS_NAMES } from './constants'

import styles from './ChooseInterests.module.scss'

const ChooseInterests = ({ tags, onSelect, currentStep, stepsCount }) => {
    const { t } = useTranslation()

    const [step, setStep] = useState(STEPS_ENUM.INTERESTS_SELECTOR)
    const [isCanGoNext, setIsCanGoNext] = useState(false)

    const [interestsTags, setInterestsTags] = useState([])
    const [selectedInterestsTags, setSelectedInterestsTags] = useState([])

    const [ageTags, setAgeTags] = useState([])
    const [selectedAgeTags, setSelectedAgeTags] = useState([])

    useEffect(() => {
        const _interestsTags = []
        INTERESTS_STEP_PARENT_TAGS_NAMES.forEach(tagName => {
            const tag = tags.find(tag => tag.parentTag.name === tagName && !!tag.childrenTags.length)
            if (tag) _interestsTags.push(tag)
        })
        setInterestsTags(_interestsTags)

        const _ageTags = []
        AGE_STEP_PARENT_TAGS_NAMES.forEach(tagName => {
            const tag = tags.find(tag => tag.parentTag.name === tagName)
            if (tag) _ageTags.push(tag)
        })
        setAgeTags(_ageTags)
    }, [tags])

    useEffect(() => {
        if (step === STEPS_ENUM.INTERESTS_SELECTOR) {
            setIsCanGoNext(!!selectedInterestsTags.length)
            return
        }
        if (step === STEPS_ENUM.AGE_SELECTOR) {
            setIsCanGoNext(!!selectedAgeTags.length)
            return
        }
        setIsCanGoNext(false)
    }, [step, selectedInterestsTags, selectedAgeTags])

    const onHandleNext = async () => {
        try {
            if (step === STEPS_ENUM.INTERESTS_SELECTOR) {
                const selectedTagsNames = selectedInterestsTags.map(tag => tag.name)
                const parentTags = []
                for (const tag of tags) {
                    if (!tag.childrenTags.length) continue
                    if (tag.childrenTags.some(tag => selectedTagsNames.includes(tag.name)))
                        parentTags.push(tag.parentTag)
                }
                setSelectedInterestsTags([...selectedInterestsTags, ...parentTags])
                setStep(STEPS_ENUM.AGE_SELECTOR)
            }
            if (step === STEPS_ENUM.AGE_SELECTOR) {
                onSelect([...selectedInterestsTags, ...selectedAgeTags])
            }
        } catch (err) {
            console.error(err)
        }
    }

    return (
        <div className={styles.chooseInterests}>
            <TopBar
                currentStep={currentStep - 1 + step}
                stepsCount={stepsCount}
                onNext={() => onHandleNext()}
                isCanGoNext={isCanGoNext}
            />
            <div className={styles.content}>
                {step === STEPS_ENUM.INTERESTS_SELECTOR && (
                    <InterestsSelector
                        tags={interestsTags}
                        selectedTags={selectedInterestsTags}
                        onUpdateSelectedTags={data => setSelectedInterestsTags(data)}
                        descriptionTitle={t('Please indicate your interests')}
                        descriptionSubTitle={t('This will help us offer you optimal game mechanics and templates')}
                    />
                )}
                {step === STEPS_ENUM.AGE_SELECTOR && (
                    <AgeSelector
                        tags={ageTags}
                        selectedTags={selectedAgeTags}
                        onUpdateSelectedTags={data => setSelectedAgeTags(data)}
                    />
                )}
            </div>
        </div>
    )
}

export default ChooseInterests
